<mat-dialog-content style="height: 90%;">
    <h2 mat-dialog-title>{{data['titleDialog']}}</h2>
    <h3 *ngIf="data['nameProvider']"> Provedor: {{data['nameProvider']}} </h3>
    <h4>Total: {{data['totalCost']}} </h4>
    <mat-form-field>
        <textarea   [(ngModel)]="comment" autocomplete="off" type="text" matInput #comentario rows="2" maxlength="100" placeholder="Comentario"></textarea>
        <mat-hint>{{ comentario.value.length }}/100</mat-hint>
    </mat-form-field>      
   <data-table
        [columns]="data.columnasDialog"
        [data]="data.dataTable"
        [configuration]="data.configurationDialog"
    >
    </data-table>
   
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-center" align="end" style="height: 10%;">
    <button color="warn" class="mr-1 button-save mat-elevation-z5 " 
        mat-raised-button mat-dialog-close>Cancelar</button>
    <button color="primary" class="ml-1 button-save mat-elevation-z5" 
        mat-raised-button [mat-dialog-close]="[true, comment]" cdkFocusInitial>Guardar</button>
</mat-dialog-actions>

<style>
    mat-form-field{
    width: 100% !important;
    }

    .button-save {
        width: 20%;
    }

    @media screen and (max-width: 550px) {
        .button-save {
            width: 35%;
        }
    }
 
</style>

